/* eslint-disable no-restricted-globals */
import axios, { AxiosError } from 'axios';
import { endpoint } from '../../config/endPoint/endpoint';
import { LocalStoreName } from 'shared/enum/local-store.enum';

const api = axios.create({
    baseURL: `${endpoint.api}/`,
});
api.defaults.headers.common['idShop'] = localStorage.getItem('idShop') || 'aaa';
api.interceptors.request.use(
    function (config: any) {
        const token = localStorage.getItem(LocalStoreName.TOKEN);
        config.headers = {
            Authorization: `Bearer ${token}`,
        } as any;

        return config;
    },
    function (error: any) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
api.interceptors.response.use(
    function (response: any) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    },
    async function (error: AxiosError) {
        if (error.response && error.response?.status >= 400 && error.response?.status < 500) {
            if (error?.response?.status === 401) {
                const result = await api.post('auth/retrieve-token', {
                    refreshToken: localStorage.getItem(LocalStoreName.REFRESH_TOKEN),
                });
                if (!result.data.token) {
                    location.href = '/login';
                } else {
                    localStorage.setItem(LocalStoreName.TOKEN, result.data.token);
                    return error.config ? api.request(error.config) : null;
                }
            }
            return Promise.reject(error.response.data);
        } else {
            // console.log(`${error?.response?.status}: ${error?.response?.statusText}`);
            // alert(`${error?.response?.status}: ${error?.response?.statusText}`);
        }
        return Promise.reject(error);
    }
);

export default api;
